import React, { useEffect, useState } from 'react';

import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import FloatingButton from '../../../../components/FloatingButton';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const PhoneContact = () => {
  const { nextStep, assistance_body, updateAssistanceBody } =
    useAssistanceDataContext();
  const [error, setError] = useState('');
  const [value, setValue] = useState<any>('');
  const { user } = useAuthDataContext();

  const CallNextStep = () => {
    dataLayerPush('asistencia_teléfonoUsuarioGrúa', user?.id);
    nextStep();
  };

  useEffect(() => {
    if (assistance_body.contact_information) {
      setValue(assistance_body.contact_information);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updatePhone = (event: any) => {
    const value = event.target.value;
    const phoneNumber = parsePhoneNumberFromString(value, 'AR');

    setValue(value);

    if (!/^\d+$/.test(value)) {
      setError('Solo debes incluir números');
    } else if (value.length > 13) {
      setError('Máximo 13 números');
    } else if (!phoneNumber?.isValid()) {
      setError('El número telefónico ingresado es inválido');
    } else {
      setError('');
    }

    updateAssistanceBody({
      contact_information: event.target.value,
    });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6">
              Confirmanos un teléfono para que la grúa se comunique con vos ante
              alguna eventualidad
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box my={2}>
            <Typography variant="subtitle2">Teléfono</Typography>
            <TextField
              error={!!error}
              helperText={error}
              size="small"
              name="origin"
              fullWidth={true}
              id="origin"
              placeholder="Ingresá un número de teléfono"
              variant="outlined"
              onChange={updatePhone}
              value={value}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={7}>
          <FloatingButton
            onClick={() => CallNextStep()}
            disabled={!value || !!error}
          >
            Continuar
          </FloatingButton>
        </Grid>
      </Grid>
    </>
  );
};

export default PhoneContact;
